import React from "react"
import { Anchor } from "./link"

export const MapLink = (props: {
    query?: string | { lat: number, lng: number },
    text?: React.ReactNode,
    disabled?: boolean,
    hideIcon?: boolean,
}) => <Anchor target="_blank"
    href={`https://www.google.com/maps/search/?api=1&query=${typeof props.query == "string" ? props.query : `${props.query?.lat},${props.query?.lng}`}`}
>
        {props.query && !props.disabled && !props.hideIcon && <i className="far fa-map" />} {props.text}
    </Anchor>